import { render } from "./GoogleDriveErrorModal.vue?vue&type=template&id=5a12390e&scoped=true"
import script from "./GoogleDriveErrorModal.vue?vue&type=script&lang=js"
export * from "./GoogleDriveErrorModal.vue?vue&type=script&lang=js"

import "./GoogleDriveErrorModal.vue?vue&type=style&index=0&id=5a12390e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a12390e"]])

export default __exports__